module.exports = __webpack_public_path__ + "img/home_1.8887d6da.jpg";